import { z } from 'zod';
import { UuidString } from '../../primitives.js';

/**
 * BE-1 — denorm-bundle ответственных (name+avatar) для payload задач.
 *
 * НЕ мутирует `Task` (assignees остаются сырыми UUID-refs). Это отдельный
 * UUID-keyed bundle на уровне ответа (как `nameById` в audit) — FE резолвит
 * display_name/avatar_url по user_id без N+1.
 *
 * Покрывает все referenced user_id: user-assignee.user_id И claimed_by_user_id
 * у role/group-assignee.
 *
 * Structural-only (i18n invariant): display_name/avatar_url — данные, не
 * freeform UI-текст. display_name = fullName (fallback email / короткий id),
 * avatar_url = null (колонки avatar в users нет).
 */

export const AssigneeDirectoryEntry = z.object({
  user_id: UuidString,
  display_name: z.string().min(1),
  avatar_url: z.string().nullable(),
});
export type AssigneeDirectoryEntry = z.infer<typeof AssigneeDirectoryEntry>;

export const AssigneeDirectory = z.array(AssigneeDirectoryEntry);
export type AssigneeDirectory = z.infer<typeof AssigneeDirectory>;
